module.exports = __webpack_public_path__ + "static/media/Logo_White.8f0ac933.png";